import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandPointUp } from '@fortawesome/pro-regular-svg-icons/faHandPointUp'
import { useConfig } from '@peracto/peracto-config'
import { Button } from '../../../components/Button'
import { isInStorefront } from '../../utils/isInStorefront'

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faHandPointUp} size="6x" />
    </div>
)

const ButtonsComponent = ({
    state: {
        buttons = [],
        direction = 'row',
        justifyContent = 'flex-start',
        spacing = 10,
        selectedButtonIndex = null,
    },
    isEditMode,
    onChange,
    focused,
}) => {
    const config = useConfig()

    const editorConfig = config.get('editorConfig')
    const buttonVariants = editorConfig?.buttonVariants

    const inStorefront = isInStorefront()

    return (
        <>
            {buttons?.length > 0 ? (
                <div
                    className="flex content__buttons"
                    style={{
                        ...(direction === 'row' && {
                            flexDirection: 'row',
                            justifyContent: justifyContent,
                        }),
                        ...(direction === 'column' && {
                            flexDirection: 'column',
                            alignItems: justifyContent,
                        }),
                    }}
                >
                    {buttons.map((button, idx) => {
                        return (
                            <Button
                                key={`btn_${Math.floor(Math.random() * 10000)}`}
                                className="content__button disabled:opacity-[0.8] disabled:cursor-not-allowed max-w-full"
                                href={button.url}
                                style={{
                                    boxShadow:
                                        selectedButtonIndex === idx &&
                                        focused &&
                                        'inset 0 0 0 3px yellow',
                                    marginLeft:
                                        idx > 0 &&
                                        direction === 'row' &&
                                        !['space-between', 'space-around'].includes(justifyContent)
                                            ? `${spacing}px`
                                            : 0,
                                    marginTop:
                                        idx > 0 &&
                                        direction === 'column' &&
                                        !['space-between', 'space-around'].includes(justifyContent)
                                            ? `${spacing}px`
                                            : 0,
                                    width: button.width === 'full' ? '100%' : 'auto',
                                }}
                                variants={buttonVariants}
                                variantColor={button.variant}
                                variantStyle={button.style}
                                size={button.size}
                                onClick={e => {
                                    if (isEditMode) {
                                        e.preventDefault()
                                        onChange({ selectedButtonIndex: idx })
                                    }
                                }}
                                {...(button.openInNewTab && { target: '_blank' })}
                            >
                                {button.label}
                            </Button>
                        )
                    })}
                </div>
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </>
    )
}

export default ButtonsComponent
